import { Injectable } from "@angular/core";
import { AppService } from "@irb/app.service";
import { IPortfolioResultResponse, IPortfolioResultSECRebal } from "@irb/irb-editors/editor-portfolio-result/editor-portfolio-result.model";
import { IAlertDialogData } from "@irb/app.model";
import { IrbAppEvents } from "@irb/app.events";
import { PrOrdersService } from "@irb/irb-editors/editor-portfolio-result/services/pr-orders.service";
import { PrOrdersCacheService } from "@irb/irb-editors/editor-portfolio-result/services/pr-orders-cache.service";

@Injectable({
  providedIn: "root",
})
export class PrSwapExchangeService {
  constructor(private as: AppService, private pros: PrOrdersService, private procs: PrOrdersCacheService) {}

  createSwapExchangeEditWarningDialog(data: IPortfolioResultResponse, item: IPortfolioResultSECRebal, snapShotItem: IPortfolioResultSECRebal, cbFunc: Function, cbFuncCancel: Function) {
    this.as.fireEvent(IrbAppEvents.SHOW_CONFIRMATION, {
      dTitle: "Swap/Exchange Order Edit",
      msg: "Sell and Buy amounts must be equal in order for the trades to generate as a swap/exchange order. Continuing with the edit may cause the trades to generate as seperate individual orders.",
      onProceed: () => {
        cbFunc();
      },
      onCancel: () => {
        this.createSwapExchangeEditWarningDialogOnCancel(data, item, snapShotItem);
        cbFuncCancel();
      }
    } as IAlertDialogData);
  }

  createSwapExchangeEditWarningDialogOnCancel(data: IPortfolioResultResponse, item: IPortfolioResultSECRebal, snapShotItem: IPortfolioResultSECRebal) {
    item.txnType = snapShotItem.txnType;
    item.txnAmt = snapShotItem.txnAmt;
    item.txnShares = snapShotItem.txnShares;

    for(let i = 0; i < snapShotItem.lotRebalanceSummaryDTOList?.length; i++) {
      item.lotRebalanceSummaryDTOList[i].txnType = snapShotItem.lotRebalanceSummaryDTOList[i].txnType;
      item.lotRebalanceSummaryDTOList[i].txnAmt = snapShotItem.lotRebalanceSummaryDTOList[i].txnAmt;
      item.lotRebalanceSummaryDTOList[i].txnShares = snapShotItem.lotRebalanceSummaryDTOList[i].txnShares;
    }

    this.pros.calBasedonPOValChange(data, item);
  }


  getSwapExchangeOrders(data: IPortfolioResultResponse, swapExchangeMapId: number, cbFunc: Function) {
    const a: Array<IPortfolioResultSECRebal> = [];

    data.secRebalDTOList.forEach((item: IPortfolioResultSECRebal) => {
      if (item.swapExchangeMapId === swapExchangeMapId) {
        a.push(item);
      }
    });

    cbFunc(a);
  }

  confirmSwapExchangeIntegrity(data: IPortfolioResultResponse, item: IPortfolioResultSECRebal, snapShotItem: IPortfolioResultSECRebal, cbFunc: Function, cbFuncCancel: Function) {
    if (item.swapExchange) {
      this.getSwapExchangeOrders(data, item.swapExchangeMapId, (items: Array<IPortfolioResultSECRebal>) => {
        let buySum = 0;
        let sellSum = 0;

        for (let i = 0; i < items.length; i++) {
          if (items[i].txnType === "BUY") {
            buySum += items[i].txnAmt;
          } else {
            sellSum += items[i].txnAmt;
          }
        }

        // confirm that buy and sell amounts are the same
        if (buySum !== sellSum) {
          this.createSwapExchangeEditWarningDialog(data, item, snapShotItem, cbFunc, cbFuncCancel);
        } else {
          cbFunc();
        }
      });
    } else {
      cbFunc();
    }
  }
}
